export default {
  dismissText: 'Annuller'
};
